import axios from 'axios';
import { useCookies } from "vue3-cookies";
import router from '../router/index'
import { useAuthStore } from '@/stores/authStore'

const { cookies } = useCookies();
// dev адрес
// const base_url = 'http://127.0.0.1:8000/api/';

// prod адрес
// const base_url = 'https://memorial.cmirit.ru/api/';

// prod - dev адрес
// const base_url = 'https://memorial-dev.cmirit.ru/api/';


// export const media__root = base_url.slice(0, -1);

// ...............................................................................
const BASE_URLS = {
  development: 'http://127.0.0.1:8000/api/',
  staging: 'https://inv-dev.gisuz.ru/api/',
  production: `${location.protocol}//${location.host}/api/`,
};

export function getBaseUrl() {
  const location = document.location;
  if (location.host.includes('localhost')) {
      return BASE_URLS.development;
  } else if (location.host.includes('inv-dev.gisuz.ru')) {
      return BASE_URLS.staging;
  } else {
      return BASE_URLS.production;
  }
}


export const media__root = getBaseUrl().slice(0, -1);

// ...............................................................................
/**
 *
 * Корневой адрес api и открытие подключения к нему
 *
 */

const BASE_URL = axios.create({
    baseURL: getBaseUrl(),
    headers: {
        contenttype: 'application/json',
    },
})

/**
 *
 * Обработка ошибки запроса при статусе неавторизован и истечении срока действия токена
 *
 */

BASE_URL.interceptors.response.use(
  (response) => response, // Успешный ответ
  async (err) => {
      const originalRequest = err.config;
      const authStore = useAuthStore();

      if (err.response) {
          switch (err.response.status) {
              case 400:
                  // Обработка ошибок 400
                  console.error('Ошибка 400:', err.response.data);
                  break;

              case 401:
                  if (err.response.data.type === 'DRF_REFRESH_TOKEN_FAILED') {
                      // Перенаправление на страницу входа, если токен обновления недействителен
                      router.push({ name: 'login' });
                  } else if (cookies.get('memorial35_refresh_token')) {
                      if (!originalRequest._retry) {
                          originalRequest._retry = true;
                          try {
                              await authStore.refreshToken(); // Обновляем токен
                              return BASE_URL(originalRequest); // Повторяем запрос
                          } catch (error) {
                              console.error('Ошибка обновления токена:', error);
                              router.push({ name: 'login' });
                          }
                      }
                  } else {
                      router.push({ name: 'login' });
                  }
                  break;

              case 403:
                  if (err.response.data.type === 'DRF_OBTAIN_TOKEN_FAILED') {
                    console.error('Ошибка 403:', err.response.data.description);
                  }
                  break;

              case 500:
                  // Обработка ошибок 500
                  console.error('Ошибка 500:', err.response.data);
                  break;

              default:
                  console.error('Неизвестная ошибка:', err.response.data);
                  break;
          }
      }

      return Promise.reject(err);
  }
);


BASE_URL.interceptors.request.use((config) => {
  const accessToken = cookies.get('memorial35_access_token');
  if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
  }
  return config;
});


export function getAuthHeader() {
  const accessToken = cookies.get('memorial35_access_token');
  return accessToken ? `Bearer ${accessToken}` : '';
}

export { BASE_URL};
